var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProfileInnerHeaderUpper',{staticClass:"profile-guardian-header-container",attrs:{"google-mail":_vm.googleMail,"photo-url":_vm.photoUrl,"name":_vm.name}})}
var staticRenderFns = []

export { render, staticRenderFns }